export default {
  checkout: {
    id: 'gift_cards_checkout_button',
    defaultMessage: 'Checkout',
  },
  giftCardPrice: {
    id: 'sticky_bar_bottom_gift_card_price',
    defaultMessage: 'digital gift card',
  },
}
